import { render, staticRenderFns } from "./OrderDetailSms.vue?vue&type=template&id=268e2dc8&"
import script from "./OrderDetailSms.vue?vue&type=script&lang=js&"
export * from "./OrderDetailSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports